import { render } from "./Fizzbuzz.vue?vue&type=template&id=7822655c&scoped=true&ts=true"
import script from "./Fizzbuzz.vue?vue&type=script&lang=ts"
export * from "./Fizzbuzz.vue?vue&type=script&lang=ts"

import "./Fizzbuzz.vue?vue&type=style&index=0&id=7822655c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7822655c"]])

export default __exports__